(function () {
	'use strict';
	$(document).ready(function () {

		// Smooth scroll to
		$('.scroll-animation').on('click', function (e) {
			e.preventDefault();

			const href = $(this).attr('href');
			if (href) {
				$("html, body").animate({
					scrollTop: $(href).offset().top
				}, 1000);
			}
		});

		$('.scroll-animation a').on('click', function (e) {
			e.stopPropagation();
		});

		//Search trigger
		$('.search-trigger').click(function () {
			$(this).toggleClass('active');
			$('.search-panel').fadeToggle('active');
			return false;
		});


		document.querySelectorAll('.articles-swiper').forEach((swiperContainer) => {
			new Swiper(swiperContainer, {
				slidesPerView: 1,
				//loop: true,
				//autoHeight: true,
				observeParents: true,
				observer: true,
				autoplay: {
					delay: 5000
				},
				navigation: {
					lockClass: 'navigation-lock',
					prevEl: '.navigation-button-prev',
					nextEl: '.navigation-button-next',
				},
				breakpoints: {
					767: {
						slidesPerView: 2,
						spaceBetween: 50
					},
					991: {
						slidesPerView: 3,
						spaceBetween: 70
					}
				}
			})
		})

		//Clicked outside of element
		window.clickedOutside = function (targetToClose, callback, _excludes = []) {
			const excludes = Array.isArray(_excludes) ? _excludes : [_excludes];
			const $target = $(targetToClose);

			if (typeof callback !== "function") {
				console.error('Callback has to be a function!');
				return null;
			}

			$('body').on('click', function (e) {
				const clickedElement = e.target;
				const isTargetVisible = $target.css('display') !== 'none';
				const isClickedElementExcluded = excludes.some((exclusion) => $(exclusion).is(clickedElement) || !!$(exclusion).has(clickedElement).length);
				const isClickedElementTarget = $target.is(clickedElement);
				const isClickedElementATargetChild = $target.has(clickedElement).length === 0;

				if (
					isTargetVisible &&
					!isClickedElementExcluded &&
					!isClickedElementTarget &&
					isClickedElementATargetChild
				) {
					callback($target, excludes);
				}
			});
		}

		// Object fit IE11 polyfill
		objectFitImages();
	});
}(jQuery));
